import { render, staticRenderFns } from "./CallMobileAddPhoneIssue.vue?vue&type=template&id=bbc181b8"
import script from "./CallMobileAddPhoneIssue.vue?vue&type=script&lang=js"
export * from "./CallMobileAddPhoneIssue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports